import { SubtreeController } from "subtree.js/core";
import type { AppDeps } from "../../app-deps";
import { chooseSellingPath, type SellingPath, sellingPath } from "../../core/primitives/onboarding";
import { OnboardingSellingActions, OnboardingSellingState } from "./onboarding-selling-model";

export type OnboardingSellingDeps = Pick<AppDeps, "storeRepository">;

export interface OnboardingSellingRouting {
  toShop(storeId: string): void;
  toShow(storeId: string): void;
  toLocations(storeId: string): void;
}

/**
 * Step 2: how the business sells. A vendor at shows trades from a booth the
 * table brings, so is not asked for premises; a shop is. Either may add the
 * other later in Settings.
 */
export class OnboardingSellingController extends SubtreeController implements OnboardingSellingActions {
  readonly state = new OnboardingSellingState();

  constructor(
    readonly deps: OnboardingSellingDeps,
    readonly routing: OnboardingSellingRouting,
  ) {
    super();
    this.subtree.put(OnboardingSellingState, this.state);
    this.subtree.put(OnboardingSellingActions, this);
    this.sync(() => {
      const storeId = deps.storeRepository.shopId;
      this.state.storeId.value = storeId;
      this.state.path.value = storeId ? sellingPath(storeId) : null;
    }, [deps.storeRepository]);
  }

  choose = (path: SellingPath) => {
    const storeId = this.state.storeId.value;
    if (!storeId) return;
    chooseSellingPath(storeId, path);
    this.state.path.value = path;
    if (path === "shows") this.routing.toShow(storeId);
    else this.routing.toLocations(storeId);
  };

  back = () => {
    this.routing.toShop(this.state.storeId.value ?? "");
  };
}
